import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const INSTAGRAM_URL = 'https://www.instagram.com/hakacompany/';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        <nav className="footer-nav">
          <button onClick={() => navigate('/about')} className="footer-link">Sobre</button>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-link">Fotos</a>
        </nav>
        <div className="footer-social">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram da HAKA">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
              <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
